import React from 'react'
import cx from 'classnames'
import { Icon } from 'components/shared/Icon/Icon'
import styles from './InfoStats.module.scss'

type InfoStatsProps = {
  label: React.ReactNode
  icon: any
  value: React.ReactNode
  iconClassName?: string
}

export const InfoStats = ({
  label,
  icon,
  value,
  iconClassName,
}: InfoStatsProps) => {
  return (
    <div className={styles.container}>
      <Icon
        className={cx(styles.icon, {
          [iconClassName ?? '']: Boolean(iconClassName),
        })}
        icon={icon}
        size={24}
      />
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{value}</div>
    </div>
  )
}
